<template>
    <div
        class="shortcut-box"
        ref="scrollableDiv"
        @click="
            {
                open = null;
            }
        ">
        <!-- 上下条数据 -->
        <div class="tf-buttons">
            <button @click="lastitem">上条<br />数据</button>
            <button @click="nextitem">下条<br />数据</button>
            <button @click="normalView">切换<br />视图</button>
        </div>

        <!-- 搜索条件 -->
        <div class="person-info">
            <div class="contact-me" id="contact">
                <!-- 规则解释 -->
                <div style="display: flex" v-show="false">
                    <h1>搜索条件</h1>
                    <el-tooltip class="box-item" effect="dark" content="Top Center prompts info" placement="top">
                        <template #content> 默认全部选择,每个选项只能单选或全选;<br />必须先选择手机品牌,才能选择型号;<br />自动给出拍卖场的对应手机选项组合 </template>
                        <el-icon>
                            <QuestionFilled />
                        </el-icon>
                    </el-tooltip>
                </div>
                <!-- 搜索条件 -->
                <div class="text-center-row">
                    <div class="row">
                        <div class="form-group">
                            <div class="input-group">
                                <!-- 平台 -->
                                <div class="custom-select" :class="{ open: isOpen === 'select1' }">
                                    <input class="input" type="text" readonly :value="sourceSelect" placeholder="选择平台--全选" @click="toggleOptions('select1')" />
                                    <div class="options" v-if="selectdata && selectdata.success">
                                        <div class="option" @click="allselect('select1')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(items, index) in selectdata.data.sourcesList"
                                            :key="index"
                                            @click="selectOption(items, 'select1')"
                                            :title="items">
                                            &nbsp;{{ items }}
                                        </div>
                                    </div>
                                </div>

                                <!-- 等级 -->
                                <div class="custom-select" :class="{ open: isOpen === 'select2' }">
                                    <input class="input" type="text" readonly :value="gradeSelect" placeholder="选择等级--全选" @click="toggleOptions('select2')" />
                                    <div class="options" v-if="selectdata && selectdata.success">
                                        <div class="option" @click="allselect('select2')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(option, index) in selectdata.data.gradeList"
                                            :key="index"
                                            @click="selectOption(option, 'select2')"
                                            :class="{ selected: gradeSelect.includes(option) }"
                                            :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div>

                                <!-- 壳瑕疵 -->
                                <div class="custom-select" :class="{ open: isOpen === 'select8' }">
                                    <input class="input" type="text" readonly :value="shuckSelect" placeholder="选择壳瑕疵--全选" @click="toggleOptions('select8')" />
                                    <div class="options" v-if="selectdata && selectdata.success">
                                        <div class="option" @click="allselect('select8')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(option, index) in selectdata.data.shuckList"
                                            :key="index"
                                            @click="selectOption(option, 'select8')"
                                            :class="{ selected: shuckSelect.includes(option) }"
                                            :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div>
                                <!-- 屏瑕疵 -->
                                <div class="custom-select" :class="{ open: isOpen === 'select9' }">
                                    <input class="input" type="text" readonly :value="screenSelect" placeholder="选择屏瑕疵--全选" @click="toggleOptions('select9')" />
                                    <div class="options" v-if="selectdata && selectdata.success">
                                        <div class="option" @click="allselect('select9')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(option, index) in selectdata.data.screenList"
                                            :key="index"
                                            @click="selectOption(option, 'select9')"
                                            :class="{ selected: screenSelect.includes(option) }"
                                            :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div>

                                <!-- todo 选择成色 -->
                                <!-- <div class="custom-select" :class="{ open: isOpen === 'select7' }">
                                    <input
                                        class="input"
                                        type="text"
                                        readonly
                                        :value="conditonSelect"
                                        placeholder="选择成色--全选"
                                        @click="toggleOptions('select7')" />
                                    <div class="options">
                                        <div class="option" @click="allselect('select7')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(option, index) in conditons"
                                            :key="index"
                                            @click="selectOption(option, 'select7')"
                                            :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                            <div class="input-group">
                                <!-- 品牌 -->
                                <div class="custom-select" :class="{ open: isOpen === 'select3' }">
                                    <input class="input" type="text" readonly :value="brandSelect" placeholder="选择品牌--全选" @click="toggleOptions('select3')" />
                                    <div class="options" v-if="selectdata && selectdata.success">
                                        <div class="option" @click="allselect('select3')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(option, index) in selectdata.data.brandList"
                                            :key="index"
                                            @click="selectOption(option, 'select3')"
                                            :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div>
                                <!-- 型号 -->
                                <div class="custom-select" :class="{ open: isOpen === 'select4' }">
                                    <input class="input" type="text" readonly :value="modelSelect" placeholder="选择型号--全选" @click="toggleOptions('select4')" />
                                    <div class="options" v-if="selectbrand && selectbrand.success">
                                        <div class="option" @click="allselect('select4')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(option, index) in selectbrand.data.modelList"
                                            :key="index"
                                            @click="selectOption(option, 'select4')"
                                            :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div>

                                <!-- 颜色 -->
                                <div class="custom-select" :class="{ open: isOpen === 'select5' }">
                                    <input class="input" type="text" readonly :value="colorSelect" placeholder="选择颜色--全选" @click="toggleOptions('select5')" />
                                    <div class="options" v-if="selectbasicinfo && selectbasicinfo.success">
                                        <div class="option" @click="allselect('select5')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(option, index) in selectbasicinfo.data.colorList"
                                            :key="index"
                                            @click="selectOption(option, 'select5')"
                                            :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div>

                                <!-- 容量 -->
                                <div class="custom-select" :class="{ open: isOpen === 'select6' }">
                                    <input class="input" type="text" readonly :value="capacitySelect" placeholder="选择容量--全选" @click="toggleOptions('select6')" />
                                    <div class="options" v-if="selectbasicinfo && selectbasicinfo.success">
                                        <div class="option" @click="allselect('select6')">&nbsp;全选</div>
                                        <div
                                            class="option"
                                            v-for="(option, index) in selectbasicinfo.data.capacityList"
                                            :key="index"
                                            @click="selectOption(option, 'select6')"
                                            :title="option">
                                            &nbsp;{{ option }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="button">
                    <button class="btn" @click="menuselect(patch)">查询</button>
                    <button class="btn" @click="resetSelection()">重选</button>
                </div>
            </div>
        </div>
        <hr style="width: 95%; margin-top: 0" />
        <!-- 数据展示 -->
        <section class="section">
            <div v-if="sisadmin">
                <input type="text" v-model="wwe" placeholder="批次号查询,如20240730_2" />
                <button @click="test(wwe)">测试</button>{{ wwe }}
            </div>
            <!-- 分页控件 -->
            <!-- todo 将分页控件放在 页尾 -->
            <el-pagination
                v-if="allpages >= 1"
                v-model:currentPage="currentPage"
                v-model:page-size="itemsPerPage"
                :page-sizes="[1, 50, 100, 200, 500]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="allpages"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                style="display: flex; justify-content: center; margin-top: 20px" />
            <!-- 标题 -->
            <!-- <div class="header"></div> -->
            <div v-if="error" class="error-message">{{ error }}</div>

            <!-- 数据 -->
            <div v-if="data">
                <!-- 获取到数据 -->
                <div v-if="data.success">
                    <div class="bbit" style="margin-top: 30px" v-if="tableData && tableData.length > 0">
                        <!-- 列表 -->
                        <div v-for="(item, index) in tableData" :key="index" class="item" v-loading="loading" ref="tableRef">
                            <ul class="services" style="position: relative">
                                <li class="services__item" :class="{ selected: selectedIndex === index }" @click="selectItem(item, index)">
                                    <div style="display: flex">
                                        <div>
                                            <!-- 标题 -->
                                            <h3 style="display: flex; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                                                <!-- 起拍价 -->
                                                <span class="pprice">¥{{ item.upsetPrice }}</span>
                                                <div>
                                                    <span style="font-size: 12px; vertical-align: bottom; margin-bottom: 0; padding-bottom: 0; margin-right: 9px"> 起拍 </span>
                                                </div>
                                                <!-- 其他信息 -->
                                                <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                                                    {{ item.model }} <span v-if="item.ram" style="margin-left: 8px">{{ item.ram }}+ </span> {{ item.storage }}
                                                    {{ item.color }}
                                                </div>
                                            </h3>

                                            <div style="display: flex; width: 100%; justify-content: space-between">
                                                <p
                                                    style="display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
                                                    :title="parseQualityDesc(item.qualityDesc)">
                                                    <!-- 等级 -->
                                                    <span
                                                        v-if="item.authorization"
                                                        class="yy"
                                                        style="background-color: rgb(250, 216, 27); border-radius: 4px; margin-left: 6px; padding: 2px; color: rgb(80, 66, 154)">
                                                        <span style="width: 440px">
                                                            {{ item.grade }}
                                                        </span>
                                                    </span>
                                                    <!-- 商户 -->
                                                    <span
                                                        v-if="item.authorization"
                                                        class="yy"
                                                        style="background-color: red; border-radius: 4px; margin-left: 6px; padding: 2px; color: white">
                                                        {{ item.authorization }}
                                                    </span>
                                                    <!-- 购买渠道 -->
                                                    <span
                                                        v-if="item.purchaseChannel"
                                                        class="yy"
                                                        style="background-color: green; border-radius: 4px; margin-left: 6px; padding: 2px; color: white">
                                                        {{ item.purchaseChannel }}
                                                    </span>
                                                    <!-- 购买渠道 -->
                                                    <span class="yy" style="background-color: #00000000; border-radius: 4px; margin-left: 6px; padding: 2px; color: #00000000">
                                                        占位符
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 图片logo显示 -->
                                    <img v-if="item.sources == '采货侠'" class="profile-img" src="@/assets/images/chx.png" alt="" />
                                    <img v-else-if="item.sources == '回收宝'" class="profile-img" src="@/assets/images/hsb.jpg" alt="" />
                                    <img v-else-if="item.sources == '小当竞拍'" class="profile-img" src="@/assets/images/xd.png" alt="" />
                                </li>
                            </ul>
                        </div>
                        <!-- 上下页 -->
                        <div class="pagination">
                            <nav v-if="allpages >= 1">
                                <ul class="pagination">
                                    <!-- 上一页按钮 -->
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <a class="page-link" href="#" @click.prevent="prevPage()">上一页</a>
                                    </li>
                                    <!-- 下一页按钮 -->
                                    <li class="page-item" :class="{ disabled: currentPage === allpages }">
                                        <a class="page-link" href="#" @click.prevent="nextPage()">下一页</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <!-- 错误提示 -->
                <div v-else>
                    <p class="error-message">获取数据失败: {{ data }}</p>
                </div>
            </div>
        </section>
        <FixedButtons @scroll-to-top="scrollToTop" />
    </div>
    <!-- 验机报告 -->
    <div style="width: 50%">
        <detailsCardView ref="detailsCardView" @call-closePopup="closePopup()" :orderAccountList="orderAccountList" />
    </div>
</template>

<script>
    import FixedButtons from "@/components/FixedButtons.vue";
    import detailsCardView from "@/views/details/testdetailsCardView.vue";
    import axios from "axios";
    import qs from "qs";
    import { mapActions, mapGetters } from "vuex";

    export default {
        components: { detailsCardView, FixedButtons },
        data() {
            return {
                sisadmin: localStorage.authRoleVOList.includes("管理员"),

                // 画廊
                activePhoto: 0,
                activeImg: 0,

                nickname: localStorage.getItem("nickname"),
                nid: localStorage.sa,

                platformURL: "/api/systemPlatformInfo/platForm/init",
                informationListURL: "/api/systemEvaluatePrice/queryByPage",
                informationURL: "/api/systemEvaluatePrice/init",
                buyitURL: "/api/orderDetails/add",
                extraBuyURL: "/api/orderDetails/currentOrderList",

                search: { id: -1, userAccount: -1 },

                // el 表格
                tableData: [],
                tempPlatform: { name: "", id: "" },

                index: 1,
                // 图片放大
                showPopup: false,
                currentImageUrl: "",

                loading: false,
                // ================================
                testshow: process.env.VUE_APP_SHOW,
                accountURL: "/api/externalAccount/queryExternalAccount",
                orderByURL: "/api/externalAccount/queryOrderExternalAccount",
                warepriceURL: "/api/warePrice/queryWarePrice",
                optioniniURL: "/api/warePrice/init",

                wwe: "20240821_2",
                ttkss: localStorage.nickname,
                selectedIndex: -1,
                // 下拉框数据
                conditons: ["开发中,成色不可用"],

                isOpen: false,

                // ???
                item: "",
                data: null,
                error: null,
                // patch:null,
                currentPage: 1, // 当前页码
                itemsPerPage: 100, // 每页显示条目数
                maxVisiblePages: 5, // 最多显示的页码数量
                gotoPageNumber: 1, // 用来存储用户输入的页码
                allpages: 1, // 总页数
                datatogo: "", // 要向vuex传递的数据

                // 下拉框的备选值
                selectdata: null,
                selectsource: null,
                selectbrand: null,
                selectmodel: null,
                selectbasicinfo: null,

                // 下拉框的选定值
                sourceSelect: null,
                gradeSelect: [],
                screenSelect: [],
                shuckSelect: [],

                brandSelect: null,
                modelSelect: null,
                colorSelect: null,
                capacitySelect: null,
                conditonSelect: null,

                // 右侧滚轮
                scrollableDiv: null,
                orderAccountList: [], // 下单账号
            };
        },
        watch: {
            // 当每页展示条目数量改变时，重新计算总页数并更新当前页码
            itemsPerPage() {
                // 返回第一页
                this.currentPage = 1;
                // 重新从服务器获取数据等
                this.menuselect();
            },
        },
        computed: {
            ...mapGetters("shared", ["getSharedData", "getCanbuyData"]),

            sharedData() {
                return this.getSharedData;
            },
            satoken() {
                return this.$store.getters.getSatoken;
            },

            // 计算总页数
            totalPages() {
                return this.allpages;
            },

            // 根据当前页码和可见页码范围计算当前显示的页码数组
            visiblePages() {
                const pages = [];
                const totalPageCount = this.totalPages;
                const maxPages = this.maxVisiblePages;
                const currentPage = this.currentPage;

                if (totalPageCount <= maxPages) {
                    for (let i = 1; i <= totalPageCount; i++) {
                        pages.push(i);
                    }
                } else {
                    let left = Math.max(1, currentPage - Math.floor(maxPages / 2));
                    let right = Math.min(totalPageCount, left + maxPages - 1);

                    if (right - left + 1 < maxPages) {
                        left = Math.max(1, right - maxPages + 1);
                    }

                    for (let i = left; i <= right; i++) {
                        pages.push(i);
                    }

                    if (left > 1) {
                        pages.unshift("...");
                        pages.unshift(1);
                    }
                    if (right < totalPageCount) {
                        pages.push("...");
                        pages.push(totalPageCount);
                    }
                }

                return pages;
            },
        },
        mounted() {
            // 需要回到顶部的div
            this.scrollableDiv = this.$refs.scrollableDiv;
        },
        // 进入页面时就获取数据
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getinitData(null);
            });
        },
        methods: {
            ...mapActions("shared", ["updateSharedData", "updateCanbuyData"]),
            // 切换回原来的视图
            normalView() {
                // changeToPath(this.$router, "/treasure");
            },

            //获取下单账号
            getOrderAccount(item) {
                axios
                    .get(this.accountURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: item.sources,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((res) => {})
                    .catch((error) => {})
                    .finally(() => {
                        this.loading = false;
                    });
            },
            // 页面置顶
            scrollToTop() {
                this.scrollableDiv.scrollTo({
                    top: 0,
                    behavior: "auto",
                });
            },

            // 下拉框显隐
            toggleOptions(selectId) {
                if (this.isOpen) {
                    this.isOpen = this.isOpen === selectId ? null : selectId;
                } else {
                    this.isOpen = selectId;
                }
            },
            // 选择选项
            selectOption(option, selectId) {
                if (selectId === "select1") {
                    this.sourceSelect = option;
                } else if (selectId === "select2") {
                    // this.gradeSelect = option;
                    if (this.gradeSelect.includes(option)) {
                        // 如果选项已经存在，移除它
                        this.gradeSelect = this.gradeSelect.filter((item) => item !== option);
                    } else {
                        // 如果选项不存在，添加它
                        this.gradeSelect.push(option);
                    }
                } else if (selectId === "select3") {
                    this.brandSelect = option;
                    // 选完 品牌 后才有 型号
                    this.setmodel();
                } else if (selectId === "select4") {
                    this.modelSelect = option;
                    // 选完 型号 后才有 其他基本信息
                    this.setbasicinfo();
                } else if (selectId === "select5") {
                    this.colorSelect = option;
                } else if (selectId === "select6") {
                    this.capacitySelect = option;
                } else if (selectId === "select7") {
                    this.conditonSelect = option;
                } else if (selectId === "select8") {
                    if (this.shuckSelect.includes(option)) {
                        // 如果选项已经存在，移除它
                        this.shuckSelect = this.shuckSelect.filter((item) => item !== option);
                    } else {
                        // 如果选项不存在，添加它
                        this.shuckSelect.push(option);
                    }
                } else if (selectId === "select9") {
                    if (this.screenSelect.includes(option)) {
                        // 如果选项已经存在，移除它
                        this.screenSelect = this.screenSelect.filter((item) => item !== option);
                    } else {
                        // 如果选项不存在，添加它
                        this.screenSelect.push(option);
                    }
                }

                // 多选悬停
                if (selectId !== "select2" && selectId !== "select8" && selectId !== "select9") {
                    this.isOpen = null;
                }
            },
            // 全选
            allselect(selectId) {
                if (selectId === "select1") {
                    this.sourceSelect = null;
                    this.isOpen = null;
                } else if (selectId === "select2") {
                    this.gradeSelect = [];
                    // this.gradeSelect = null;
                    this.isOpen = null;
                } else if (selectId === "select3") {
                    this.brandSelect = null;
                    this.isOpen = null;
                    // 选完 品牌 后才有 型号
                    this.setmodel();
                } else if (selectId === "select4") {
                    this.modelSelect = null;
                    this.isOpen = null;
                    // 选完 型号 后才有 其他基本信息
                    this.setbasicinfo();
                } else if (selectId === "select5") {
                    this.isOpen = null;
                    this.colorSelect = null;
                } else if (selectId === "select6") {
                    this.isOpen = null;
                    this.capacitySelect = null;
                } else if (selectId === "select7") {
                    this.isOpen = null;
                    this.conditonSelect = null;
                } else if (selectId === "select8") {
                    this.isOpen = null;
                    this.shuckSelect = [];
                } else if (selectId === "select9") {
                    this.isOpen = null;
                    this.screenSelect = [];
                }
            },

            // 选中列表--显示弹窗
            selectItem(item, index) {
                if (this.$refs.detailsCardView) {
                    // 在调用之前检查 selectTab 方法是否存在
                    if (typeof this.$refs.detailsCardView.selectTab === "function") {
                        this.$refs.detailsCardView.selectTab(1);
                    } else {
                        console.error("子组件中未定义 selectTab 方法");
                        return;
                    }
                }
                this.selectedIndex = index;
                // 向vuex传递数据
                this.updateSharedData(item);
                this.updateCanbuyData(true);
                // 显示弹窗
                // 获取历史出价
                axios
                    .get(this.orderByURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: item.sources,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((res) => {
                        this.orderAccountList = res.data.data;
                    });
            },
            // 上条数据
            lastitem() {
                if (this.selectedIndex > 0) {
                    this.selectedIndex--;
                    let currentItem = this.tableData[this.selectedIndex];
                    this.updateSharedData(currentItem);
                    this.updateCanbuyData(true);
                    this.scrollCurrent(this.selectedIndex);
                }
            },
            // 下条数据
            nextitem() {
                if (this.selectedIndex < this.tableData.length - 1) {
                    this.selectedIndex++;
                    let currentItem = this.tableData[this.selectedIndex];
                    this.updateSharedData(currentItem);
                    this.updateCanbuyData(true);
                    this.scrollCurrent(this.selectedIndex);
                }
            },
            scrollCurrent(idx) {
                const tableDom = this.$refs.tableRef[idx];
                if (tableDom) {
                    // tableDom.scrollIntoView({behavior: 'smooth',block:'center'})
                    tableDom.scrollIntoView({ behavior: "auto", block: "start" });
                }
            },
            // 下面是页面跳转逻辑
            // 跳转到指定页码
            gotoPage(page = this.page, patch = this.patch) {
                if (page === "...") return;
                if (page >= 1 && page <= this.totalPages) {
                    this.currentPage = page;
                    axios
                        .get(this.warepriceURL, {
                            headers: {
                                satoken: localStorage.sa,
                            },
                            params: {
                                sources: this.sourceSelect,
                                brand: this.brandSelect,
                                model: this.modelSelect,
                                color: this.colorSelect,
                                grade: this.gradeSelect,
                                capacity: this.capacitySelect,
                                patch: patch,
                                pageNo: this.currentPage,
                                pageSize: this.itemsPerPage,
                                multiplecate: false,

                                // authorization: "转转个人"
                            },
                            paramsSerializer: (params) => {
                                return qs.stringify(params, { indices: false });
                            },
                        })
                        .then((response) => {
                            this.loading = false;
                            this.data = response.data;
                            this.tableData = response.data.data.result;
                            this.allpages = response.data.data.total;
                        })
                        .catch((error) => {
                            this.data = error;
                        });
                }
            },
            // 上一页
            prevPage() {
                if (this.currentPage > 1) {
                    this.loading = true;
                    this.currentPage--;
                    this.gotoPage(this.currentPage);
                    this.scrollToTop();
                }
            },
            // 下一页
            nextPage() {
                if (this.currentPage < this.totalPages) {
                    this.loading = true;
                    this.currentPage++;
                    this.gotoPage(this.currentPage);
                    this.scrollToTop();
                }
            },
            // 指定页
            gotoSpecificPage() {
                if (this.gotoPageNumber >= 1 && this.gotoPageNumber <= this.totalPages) {
                    this.currentPage = this.gotoPageNumber;
                    this.gotoPage(this.currentPage);
                } else {
                    alert(`请输入1到${this.totalPages}之间的页码`);
                }
            },

            // 初始化筛选条件
            getselectData(patch = this.patch) {
                axios
                    .get(this.optioniniURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            patch: patch,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.selectdata = response.data;
                    })
                    .catch((error) => {
                        this.selectdata = error;
                        console.error("获取数据出错:", error);
                    });
            },
            resetbrand() {
                this.modelSelect = null;
                this.colorSelect = null;
                this.capacitySelect = null;
            },
            // 重置筛选条件
            resetSelection() {
                this.sourceSelect = null;
                this.brandSelect = null;
                this.gradeSelect = [];
                this.screenSelect = [];
                this.shuckSelect = [];
                // this.gradeSelect = null;
                this.modelSelect = null;
                this.colorSelect = null;
                this.capacitySelect = null;
                this.conditonSelect = null;

                // this.selectdata = null;
                // this.selectsource=null;
                this.selectbrand = null;
                this.selectmodel = null;
                this.selectbasicinfo = null;
            },
            // 根据平台展示品牌
            setbrand() {
                axios
                    .get(this.optioniniURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: this.sourceSelect,
                            patch: this.patch,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.selectsource = response.data;
                    })
                    .catch((error) => {
                        this.selectdata = error;
                    });
            },
            // 根据品牌展示型号
            setmodel() {
                axios
                    .get(this.optioniniURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: this.sourceSelect,
                            brand: this.brandSelect,
                            patch: this.patch,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.selectbrand = response.data;
                        this.resetbrand();

                        // 输出响应数据
                    })
                    .catch((error) => {
                        this.selectdata = error;
                        console.error("获取数据出错:", error);
                    });
            },

            // 根据 型号展示基本信息
            setbasicinfo() {
                axios
                    .get(this.optioniniURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: this.sourceSelect,
                            brand: this.brandSelect,
                            model: this.modelSelect,
                            patch: this.patch,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.selectbasicinfo = response.data;

                        // 输出响应数据
                    })
                    .catch((error) => {
                        this.selectdata = error;
                        console.error("获取数据出错:", error);
                    });
            },

            // 初始化采货列表
            ...mapGetters("auth", ["getLoginData"]),
            getinitData(patch = this.patch) {
                if (this.getLoginData()) {
                    sa = "zhenzhi " + this.getLoginData().saTokenInfo.tokenValue;
                    localStorage.setItem("sa", sa);
                } else {
                    var sa = localStorage.sa;
                }

                // patch 只在暗拍间隙生效
                delete this.patch;

                axios
                    .get(this.warepriceURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            patch: patch,
                            pageNo: this.pageNo,
                            pageSize: this.itemsPerPage,
                            multiplecate: false,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.data = response.data;
                        this.tableData = response.data.data.result;
                        this.getselectData();
                        this.allpages = response.data.data.total;
                        this.resetSelection();
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    });
            },

            // 按照条件筛选出采货数据
            menuselect(patch = this.patch, pageNo = 1) {
                // patch 只在暗拍间隙生效
                axios
                    .get(this.warepriceURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: this.sourceSelect,
                            brand: this.brandSelect,
                            model: this.modelSelect,
                            color: this.colorSelect,
                            grade: this.gradeSelect,
                            capacity: this.capacitySelect,
                            patch: patch,
                            pageNo: pageNo,
                            pageSize: this.itemsPerPage,
                            shuck: this.shuckSelect,
                            screen: this.screenSelect,
                            multiplecate: false,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.data = response.data;
                        this.tableData = response.data.data.result;
                        this.currentPage = 1;
                        this.allpages = response.data.data.total;
                        if (this.data.data.total === 0) {
                            //
                        }
                        // 输出响应数据
                    })
                    .catch((error) => {
                        this.data = error;
                    });
            },

            menuselect2(patch = this.patch, pageNo = 1) {
                // patch 只在暗拍间隙生效
                axios
                    .get(this.warepriceURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: this.sourceSelect,
                            brand: this.brandSelect,
                            model: this.modelSelect,
                            color: this.colorSelect,
                            grade: this.gradeSelect,
                            capacity: this.capacitySelect,
                            patch: patch,
                            pageNo: pageNo,
                            pageSize: this.itemsPerPage,
                            multiplecate: false,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.data = response.data;
                        this.tableData = response.data.data;
                        this.allpages = response.data.data.total;
                        if (this.data.data.total === 0) {
                            //
                        }
                        // 输出响应数据
                    })
                    .catch((error) => {
                        this.data = error;
                    });
            },

            // 测试采货数据
            test(patch = this.patch, pageNo = 1) {
                // patch 只在暗拍间隙生效
                axios
                    .get(this.warepriceURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            patch: patch,
                            pageNo: pageNo,
                            pageSize: this.itemsPerPage,
                            multiplecate: false,
                            // authorization: "转转个人"
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.data = response.data;
                        this.tableData = response.data.data.result;
                        this.patch = patch;
                        this.getselectData(patch);
                        this.allpages = response.data.data.total;
                        // 输出响应数据
                        let test = JSON.parse(response.data.data.result[2].qualityDesc);
                    })
                    .catch((error) => {
                        this.data = error;
                    });
            },
            // 处理 \"
            parseDefectUrls(defectUrl) {
                try {
                    const urls = JSON.parse(defectUrl);
                    return Object.values(urls);
                } catch (e) {
                    return [];
                }
            },
            // 处理 \"
            parseQualityDesc(desc) {
                try {
                    const quality = JSON.parse(desc);
                    let result = "";
                    for (let key in quality) {
                        result += `${key}: ${quality[key]} `;
                    }
                    return result.trim();
                } catch (e) {
                    return desc;
                }
            },

            // 改变条数
            handleSizeChange(val) {
                this.itemsPerPage = val;
                this.menuselect2();
            },

            //改变页数
            handleCurrentChange(val) {
                this.pageNo = val;
                this.gotoPage(val);
            },
        },
    };
</script>

<style lang="scss" scoped>
    // 上下条数据
    .tf-buttons {
        position: fixed;
        bottom: 160px;
        right: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        z-index: 1000;
    }

    .tf-buttons button {
        padding: 12px 15px;
        background-color: #007bff;
        color: white;
        border: none;
        border-radius: 8px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: background-color 0.3s ease, transform 0.2s ease;
    }

    .tf-buttons button:hover {
        background-color: #0056b3;
        transform: translateY(-2px);
    }

    .tf-buttons button:active {
        transform: translateY(0);
    }

    @media (max-width: 600px) {
        .tf-buttons {
            bottom: 10px;
            right: 10px;
        }

        .tf-buttons button {
            padding: 10px 20px;
        }
    }

    // 画廊
    $brand: #5c4084;

    .gallery {
        width: 90%;
        flex-direction: column;
        background-color: #ffffff;
        padding: 4px;
        border-radius: 8px;
        justify-content: center;

        .active-photo {
            width: 100%;
            margin-bottom: 5px;
            padding-bottom: 100%;
            background-size: 90%;
            background-position: center;
            background-repeat: no-repeat;
            border: 2px solid #fff;
            position: relative;

            button {
                border: none;
                background-color: transparent;
                font-size: 30px;
                color: #fff;
                opacity: 0.5;
                position: absolute;
                outline: none;
                height: 100%;

                &.previous {
                    left: 0;
                    color: black;
                    background: -moz-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
                    background: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
                    background: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
                    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);
                }

                &.next {
                    right: 0;
                    color: black;
                    background: -moz-linear-gradient(left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
                    background: -webkit-linear-gradient(left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
                    background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
                    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);
                }
            }
        }

        .thumbnails {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(55px, 1fr));
            grid-gap: 4px;

            div {
                width: 35px;
                outline: 2px solid #ffffff;
                cursor: pointer;
                padding-bottom: 55%;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                opacity: 1;

                &.active {
                    outline-color: $brand;
                    opacity: 1;
                }
            }
        }
    }

    // 下面是自定义下拉框样式
    /* CSS样式 */
    :deep(#contact .el-icon) {
        margin-top: 30px;
        margin-right: 10px;
    }

    .section {
        position: relative;
    }

    :deep(.section .icon_pop .el-icon) {
        color: #ffffff;
        position: absolute;
        top: 118px;
        left: 240px;
    }

    :deep(.el-pagination > .is-first) {
        color: #ffffff;
    }

    :deep(.el-pagination__goto) {
        color: #ffffff;
    }

    :deep(.el-pagination__classifier) {
        color: #ffffff;
    }

    .custom-select {
        // 显示出滚动条
        position: relative;
        width: 150px;
        /* 调整选择框的宽度 */
        margin-right: 20px;
    }

    .custom-select input {
        display: flex;
        width: 100%;
        padding: 10px;
        border: 1px solid #ccc;
        cursor: pointer;
        background-color: #fff;
    }

    .custom-select .options {
        // 绝对展示--不干扰其他元素位置
        position: absolute;
        display: none;
        width: 100%;
        /* 调整下拉选项的最大高度 */
        max-height: 290px;
        overflow-y: auto;
        border: 1px solid #ccc;
        background-color: #fff;
        z-index: 9002;
    }

    .custom-select .option {
        display: flex;
        /* 允许换行 */
        white-space: normal;
        /* 选项文字不换行*/
        white-space: nowrap;
        /* 长单词换行 */
        //word-wrap: break-word;
        color: #204d74;
        cursor: pointer;
    }

    // 搜索菜单选中
    .custom-select .option.selected {
        background-color: #007bff;
        color: white;
    }

    .custom-select .option.selected:hover {
        background-color: #007bff;
        color: white;
    }

    // 搜索菜单划过
    .custom-select .option:hover {
        background-color: #f0f0f0;
    }

    .custom-select.open .options {
        display: block;
    }

    // 上面是自定义下拉框样式

    /* CSS 样式，用于弹窗外观 */
    .cartover {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        /* 半透明黑色背景 */
        z-index: 9999;
        /* 弹窗位于最上层 */
    }

    .scorllpop {
        overflow: auto;
        position: fixed;
        background-color: white;
        height: 100%;
        width: 70%;
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0 0 10px rgb(12, 28, 248);
        /*	text-align: center;	*/
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
        /* 确保弹窗在黑色背景之上 */
    }

    .close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
    }

    // MIXINS
    @mixin bp-sm {
        @media (min-width: 40.625em) {
            @content;
        }
    }

    @mixin bp-md {
        @media (min-width: 48em) {
            @content;
        }
    }

    @mixin bp-lg {
        @media (min-width: 62em) {
            @content;
        }
    }

    @mixin pseudo-starter {
        content: "";
        display: block;
    }

    .shortcut-box {
        width: 50%;
        // 悬停样式变化
        transition: all 300ms ease, transform 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);

        // 页面颜色
        --color-brand-primary: hsl(var(--color-brand-primary-h), 43%, 43%);
        --color-brand-primary-h: 251;
        --color-brand-primary-s: 43%;
        --color-brand-primary-l: 43%;
        --color-brand-accent: hsl(var(--color-brand-accent-h), 96%, 61%);
        --color-brand-accent-h: 16;
        --color-brand-accent-s: 96%;
        --color-brand-accent-l: 61%;
        --color-brand-accent-bg: hsl(calc(var(--color-brand-accent-h) + 17), 100%, 96%);

        // 页面排列（排版）
        // The ratio number
        --ratio: 1.4;

        //小尺寸
        --s-6: calc(var(--s-5) / var(--ratio));
        --s-5: calc(var(--s-4) / var(--ratio));
        --s-4: calc(var(--s-3) / var(--ratio));
        --s-3: calc(var(--s-2) / var(--ratio));
        --s-2: calc(var(--s-1) / var(--ratio));
        --s-1: calc(var(--s0) / var(--ratio));
        --s0: calc(1.05rem + 0.333vw);

        // 大尺寸
        --s1: calc(var(--s0) * var(--ratio));
        --s2: calc(var(--s1) * var(--ratio));
        --s3: calc(var(--s2) * var(--ratio));
        --s4: calc(var(--s3) * var(--ratio));
        --s5: calc(var(--s4) * var(--ratio));
        --s6: calc(var(--s5) * var(--ratio));
        line-height: 1.6;
        box-sizing: border-box;

        background-color: rgba(16 18 27 / 10%);
        overflow-x: hidden;
        @include bp-sm {
            --s0: calc(1.25rem + 0.333vw);
        }

        @include bp-md {
            --s0: calc(1.4rem + 0.333vw);
        }

        @include bp-lg {
            --s0: calc(0.9rem + 0.333vw);
        }
    }

    .section {
        padding: 20px 40px;

        .header {
            height: 165px;
            z-index: -1;
            background-attachment: fixed;
        }
    }

    h2,
    h3,
    p,
    ul {
        margin: 0;
    }

    // 展示数据样式
    ul {
        padding: 0;

        li {
            list-style-type: none;
            margin-bottom: 8px;
        }
    }

    .services {
        grid-gap: var(--s2);
        margin: 0 calc(var(--s3) * -1);
        padding: var(--s6) var(--s3);
        position: relative;
        z-index: 1;
        @include bp-sm {
            grid-template-columns: repeat(7, 1fr);
            grid-template-rows: minmax(100px, 1fr);
        }

        @include bp-sm {
            padding: 0 var(--s3);
        }

        &__item {
            background: #fff;
            padding: calc(var(--s0) - 0.9rem) var(--s3);
            border-radius: 15px;

            h3 {
                color: var(--color-brand-primary);
                font-size: var(--s0);
                line-height: 1.2;
            }

            &:after {
                @include pseudo-starter;
                position: absolute;
                top: 0;
                left: 0;
                width: 50px;
                height: 50px;
                border-radius: 25px 0;
                cursor: pointer;
                transition: inherit;
                background-color: var(--color-brand-accent);
                background-size: 20px 20px;
                background-repeat: no-repeat;
                background-position: center;
            }

            img {
                border-radius: 15px 0;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 50px;
                height: 50px;
                z-index: 99999;
            }

            p {
                margin-top: var(--s-2);
                font-weight: 400;
                color: hsl(250deg, 7%, 46%);
            }
        }
    }

    // 搜索菜单栏样式
    .person-info {
        width: 100%;
        overflow: visible;
        align-items: center;
        background-color: rgba(16 18 27 / 10%);
        padding: 20px 40px;
        color: #ffffff;

        .contact-me {
            // display: flex;
            flex-direction: column;
            width: 100%;
            overflow: visible;

            .text-center-row {
                // display: flex;
                flex-wrap: wrap;
                width: 100%;

                .row {
                    .form-group {
                        .input-group {
                            display: flex;
                            flex-direction: row;
                            padding-left: 20px;
                            height: 38px;
                            width: 100%;
                            margin-bottom: 10px;
                        }
                    }

                    .input {
                        width: 100%;
                        margin-right: 30px;
                        border-radius: 2px;
                        border: 1px solid #ccc;
                    }

                    .input1 {
                        padding: 10px;
                        border-radius: 4px;
                    }

                    .input:focus {
                        border-color: #66afe9;
                        outline: 0;
                        box-shadow: inset 0 2px 2px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
                    }

                    @media screen and (max-width: 1110px) {
                        width: 100%;
                    }
                }
            }

            .button {
                .btn {
                    padding: 8px 30px;
                    border-radius: 6px;
                    background-color: #007bff;
                    border-color: #2e6da4;
                    color: #ffffff;
                    font-weight: 500;
                    margin: 20px;
                }

                .btn:hover {
                    background-color: #0056b3;
                    border-color: #204d74;
                }
            }
        }
    }

    /* 分页样式 下面 */
    .pagination {
        display: flex;
        justify-content: center;
        margin-top: 15px;
    }

    .pagination ul {
        display: flex;
        list-style-type: none;
        padding: 0;
    }

    .pagination ul li {
        margin: 0 5px;
    }

    .pagination ul li.disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    .pagination ul li.page-item a {
        text-decoration: none;
        padding: 5px 10px;
        border: 1px solid #ccc;
        border-radius: 3px;
        background-color: #f5f5f5;
    }

    .pagination ul li.page-item a:hover {
        background-color: #e9ecef;
    }

    .pagination ul li.page-item.active a {
        background-color: #007bff;
        color: white;
    }

    /* 可选：自定义分页样式 上面 */

    // 数据列表
    .services__item {
        position: relative;

        .pprice {
            color: rgb(244, 108, 68);
        }
    }

    .services__item.selected {
        background-color: var(--color-brand-accent);

        h3 {
            color: #fff;

            .pgrade {
                display: flex;
                padding-right: 4px;
                width: 65px;
                text-align: center;
                justify-content: center;
                border-radius: 4px;
                margin-right: 9px;
            }
        }

        p {
            color: hsla(0, 0%, 100%, 0.8);

            .yy {
                color: #201e1e;
            }
        }

        .pprice {
            color: rgb(31, 27, 26);
        }
    }
</style>
